import {Button, view} from '@sail/ui';
import {CallToActionComponentLogItem} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import {MetaRow} from '../../../../Chat';

export const CallToActionComponent = ({
  message,
  buttonText,
  values,
  onPress,
}: CallToActionComponentLogItem['data']) => {
  return (
    <view.div
      data-testid="custom-component-call-to-action"
      css={{textAlign: 'center'}}
    >
      {message ? (
        <MetaRow>
          <FormattedMessage {...message} values={values} />
        </MetaRow>
      ) : null}
      <Button
        css={{marginTop: 'medium'}}
        onPress={onPress}
        data-testid="restart-conversation-button"
      >
        <FormattedMessage {...buttonText} values={values} />
      </Button>
    </view.div>
  );
};
